import React from "react";
import { t } from "ttag";

import {
    CheckboxBlock,
    CheckboxInputBlock,
    EmailInputBlock,
    EmailRegistrationCheckboxBlock,
    GatingFormFieldsStream,
    OptionBlock,
    RadioInputBlock,
    SelectInputBlock,
    SubmitButtonBlock,
    TextAreaBlock,
    TextInputBlock,
} from "@reactivated";

import {
    StreamField,
    StreamFieldBlockMap,
} from "@thelabnyc/thelabui/src/components/StreamField";

import { ButtonPrimary } from "../Clickables";
import { FeaturedRichtext } from "../FeaturedRichtext";
import {
    Checkbox,
    CheckboxGroup,
    Dropdown,
    DropdownItem,
    Radio,
    RadioGroup,
    TextField,
} from "../Form";
import { RichText } from "../RichText";

import styles from "./dialog.module.scss";

const TextInput = (props: { id?: string; value: TextInputBlock }) => (
    <TextField
        id={props.id}
        label={props.value.label ?? ""}
        name={props.value.hubspot_property ?? undefined}
        isRequired={props.value.is_required ?? false}
        type="text"
    />
);

const EmailInput = (props: { id?: string; value: EmailInputBlock }) => (
    <TextField
        id={props.id}
        label={props.value.label ?? ""}
        name="email"
        isRequired={props.value.is_required ?? false}
        type="email"
    />
);

const TextArea = (props: { id?: string; value: TextAreaBlock }) => (
    <TextField
        id={props.id}
        label={props.value.label ?? ""}
        name={props.value.hubspot_property ?? undefined}
        isRequired={props.value.is_required ?? false}
        isMultiLine
    />
);

const SingleCheckbox = (props: { id?: string; value: CheckboxBlock }) => (
    <Checkbox
        id={props.id}
        name={props.value.hubspot_property ?? undefined}
        value="true"
    >
        {props.value.label}
    </Checkbox>
);

const CheckboxInput = (props: { value: CheckboxInputBlock }) => (
    <CheckboxGroup
        label={props.value.label ?? ""}
        name={props.value.hubspot_property ?? undefined}
        isRequired={props.value.is_required ?? false}
    >
        {(props.value.options ?? []).map((option: OptionBlock, i: number) => (
            <Checkbox key={i} value={option.value ?? ""}>
                {option.label}
            </Checkbox>
        ))}
    </CheckboxGroup>
);

const RadioInput = (props: { value: RadioInputBlock }) => (
    <RadioGroup
        label={props.value.label ?? ""}
        name={props.value.hubspot_property ?? undefined}
        isRequired={props.value.is_required ?? false}
    >
        {(props.value.options ?? []).map((option: OptionBlock, i: number) => (
            <Radio key={i} value={option.value ?? ""}>
                {option.label}
            </Radio>
        ))}
    </RadioGroup>
);

const SelectInput = (props: { value: SelectInputBlock }) => (
    <Dropdown
        label={props.value.label ?? ""}
        name={props.value.hubspot_property ?? undefined}
        isRequired={props.value.is_required ?? false}
    >
        {(props.value.options ?? []).map((option: OptionBlock, i: number) => (
            <DropdownItem key={i} id={option.value ?? String(i)}>
                {option.label}
            </DropdownItem>
        ))}
    </Dropdown>
);

const EmailRegistrationCheckbox = (props: {
    id?: string;
    value: EmailRegistrationCheckboxBlock;
}) => (
    <CheckboxGroup label={props.value.heading ?? t`Lean In Newsletter`}>
        <Checkbox id={props.id} name="email_registration">
            {props.value.label}
        </Checkbox>
    </CheckboxGroup>
);

const SubmitButton = (props: { value: SubmitButtonBlock }) => (
    <ButtonPrimary type="submit" style={{ alignSelf: "start" }}>
        {props.value.label}
    </ButtonPrimary>
);

const formFieldComponents: StreamFieldBlockMap<GatingFormFieldsStream> = {
    text_input: TextInput,
    email_input: EmailInput,
    text_area: TextArea,
    checkbox: SingleCheckbox,
    checkbox_input: CheckboxInput,
    radio_input: RadioInput,
    select_input: SelectInput,
    email_registration_checkbox: EmailRegistrationCheckbox,
    submit_button: SubmitButton,
    rich_text: RichText,
    featured_richtext: FeaturedRichtext,
};

export const FormFields = (props: { value: GatingFormFieldsStream }) => (
    <div className={styles.fieldsWrapper}>
        <StreamField
            tagName={React.Fragment}
            components={formFieldComponents}
            value={props.value}
        />
    </div>
);
